import { useState } from 'react';

interface UseTransferSelectionOptions {
  pendingTransferCards: any[] | undefined;
}

export const useTransferSelection = ({ pendingTransferCards }: UseTransferSelectionOptions) => {
  const [selection, setSelection] = useState<Record<string, any>>({});

  const showActionMenu = Object.values(selection).some((x: any) => x.isSelected);
  const selectAll =
    (pendingTransferCards?.length ?? 0) > 0 &&
    pendingTransferCards?.length === Object.values(selection).filter((x: any) => x.isSelected).length;

  const resetSelection = () => {
    setSelection({});
  };

  const triggerSelectAll = (isSelectAll?: boolean) => {
    const newSelection = isSelectAll
      ? pendingTransferCards?.reduce((acc: Record<string, any>, cr: any) => {
          acc[cr.cardNumber] = {
            isSelected: true,
            cardNumber: cr.cardNumber,
            selectedAccountNumber: cr.sourceContractIdentifier,
            targetAccount: cr.targetContractIdentifier,
          };
          return acc;
        }, {})
      : {};
    setSelection(newSelection ?? {});
  };

  const getNumberOfSelectedRecords = () => {
    return Object.values(selection).filter((x) => x.isSelected).length;
  };

  const handleSelectionChange = (item: any) => {
    const {
      cardNumber,
      sourceContractIdentifier: selectedAccountNumber,
      targetContractIdentifier: targetAccount,
    } = item;
    const isPrevSelected = !!selection[cardNumber] && selection[cardNumber].isSelected;
    const isSelected = !isPrevSelected;
    const newSelection = {
      ...selection,
      [cardNumber]: {
        isSelected,
        cardNumber,
        selectedAccountNumber,
        targetAccount,
      },
    };
    setSelection(newSelection);
  };

  return {
    selection,
    showActionMenu,
    selectAll,
    resetSelection,
    triggerSelectAll,
    handleSelectionChange,
    getNumberOfSelectedRecords,
  };
};
